function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #5273e6;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Menu:_Gradebook",
  "data-name": "Menu: Gradebook",
  transform: "translate(-39 -338)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_656",
  "data-name": "Path 656",
  className: "cls-1",
  d: "M12.5,1V17.5A6.25,6.25,0,0,1,0,17.5V1",
  transform: "translate(52.5 362.75) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_657",
  "data-name": "Path 657",
  className: "cls-2",
  d: "M-1381-2022.7h12.5",
  transform: "translate(1421 2372.946)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1242",
  "data-name": "Group 1242",
  transform: "translate(58 348.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_658",
  "data-name": "Path 658",
  className: "cls-2",
  d: "M-1381-2022.7h8",
  transform: "translate(1381 2026.696)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_659",
  "data-name": "Path 659",
  className: "cls-2",
  d: "M0,0H8",
  transform: "translate(4) rotate(90)"
})));

var SvgSideGradebook = function SvgSideGradebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 24.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideGradebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-gradebook.b59533c3.svg";
export { ForwardRef as ReactComponent };